module.exports = __webpack_public_path__ + "img/r-181.ee6e7c19.jpg";